
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.945 11.188L2.18 10H.164V8.96h2.219l.344-1.718-2.563.899V6.969l2.797-.899.687-3.46L.164 1.483V.313l3.68 1.289.304-1.524h.915l-.36 1.828L9.79 3.68v1.093L3.711 6.898l-.414 2.063h6.492V10H3.094l-.235 1.188h-.914zM8.68 4.226L4.508 2.883l-.57 2.875L8.68 4.227z","fill":"currentColor"}})])
          )
        }
      }
    